'use client';

import { ensureUserWayDefaultIconHidden } from '@/utils/userWayWidget';
import { useEffect } from 'react';

/**
 * US 站：根布局挂载时隐藏 UserWay 默认浮标（与自定义入口、官方 `iconVisibilityOff` 配合）。
 * 放在全局，避免依赖 `RightBottomFloating` 或 Header 子树是否渲染。
 */
export default function UserWayDefaultIconInit() {
  useEffect(() => {
    ensureUserWayDefaultIconHidden();
  }, []);
  return null;
}
